var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.959 9.476c-.395-1.32-.317-3.442-.227-4.333h-3.498c.318 1.834.052 3.656-.124 4.333c-1.843 0-3.63-.784-4.294-1.179l-1.102 3.335c2.525.441 3.81 1.174 4.136 1.487c-.463 1.444-1.813 3.017-2.43 3.625l2.794 2.113c1.093-1.89 2.315-3.072 2.79-3.428c1.35.913 2.4 2.665 2.752 3.428l2.803-2.113c-1.457-1.495-2.212-3.042-2.405-3.625c1.402-.866 3.339-1.35 4.132-1.487l-1.089-3.335c-1.487.725-3.445 1.089-4.243 1.179z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFort);
export default __webpack_public_path__ + "static/media/fort.502be39dc71de3e70e9d63879c3e22bb.svg";
export { ForwardRef as ReactComponent };